import { useAuth } from "@/context/authContext";
import { api } from "@/utils/api";
import { useState, type Dispatch, type SetStateAction } from "react";
import { toast } from "sonner";

export const useLoadData = () => {
  const { dispatch } = useAuth();
  const [loading, setLoading] = useState<{
    sessions: boolean;
    preferences: boolean;
  }>({ sessions: false, preferences: false });

  const loadSessions = async (
    setData: Dispatch<SetStateAction<{ rotations: any[]; sessions: any[] }>>,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, sessions: true }));
      const response = await api(
        "/rotations?shape=all",
        { method: "GET" },
        dispatch,
      );
      setData({ rotations: response.rotations, sessions: response.sessions });
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, sessions: false }));
    }
  };

  const loadPreferences = async (
    sessionId: string,
    setPreferences: Dispatch<
      SetStateAction<{
        searched: boolean;
        preferences: any[];
        explorations: any[];
        students: any[];
      }>
    >,
  ) => {
    try {
      setLoading((prev) => ({ ...prev, preferences: true }));
      const response = await api(
        `/enrollments/preferences/${sessionId}`,
        { method: "GET" },
        dispatch,
      );
      setPreferences({
        searched: true,
        preferences: response.preferences,
        explorations: response.explorations,
        students: response.students,
      });
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading((prev) => ({ ...prev, preferences: false }));
    }
  };

  return { loadSessions, loadPreferences, loading };
};
